import { Component, ViewEncapsulation, Input, EventEmitter, Output, OnInit } from '@angular/core';
@Component({
    selector: 'app-route-planner-option',
    templateUrl: './route-planner-option.component.html',
    styleUrls: ['./route-planner-option.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RoutePlannerOptionComponent implements OnInit  {

  @Input() optionModel: any = [];
  @Input() optionId: string  ;
  @Input() isImageLogo = false;

  @Output() onOptionSelected: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  // As we do have span (next to input) and it doesn't have focus event so we need to get its Id and do the trick
  ngOnInit(): void {
    this.optionId = 'route-planner-option-id' + this.optionId ;
  }

  onCheckedOption(option) {
    this.onOptionSelected.emit(option);
  }

  onFocus() {
    const el: HTMLElement = document.getElementById(this.optionId);
    (el !== null) ? el.classList.add('focus') : null;
  }

  onBlur() {
    const el: HTMLElement = document.getElementById(this.optionId);
    (el !== null) ? el.classList.remove('focus') : null;
  }

}
